import {
  setPaymentData,
  setUserFundData,
  setOrderIdData,
  setFundConfigData,
  setFundsData
} from "./slice";

export const setPayment = (data) => (dispatch) => {
  dispatch(setPaymentData(data));
};

export const setUserFund = (data) => (dispatch) => {
  dispatch(setUserFundData(data));
};

export const setOrderId = (data) => (dispatch) => {
  dispatch(setOrderIdData(data));
};

export const setFundConfig = (data) => (dispatch) => {
  dispatch(setFundConfigData(data));
};

export const setFunds = (data) => (dispatch) => {
  dispatch(setFundsData(data));
};
